import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOrganizationUserDetailsPath = (
  organizationId: string = ':organizationId',
  userId: string = ':userId'
) => {
  return urlHelper(`/organization/${organizationId}/users/${userId}/details`);
};
